
import { useEffect, useState } from 'react';

import './TopNavbar.css';
import logo from '../../assets/logos/laurimikael_logo_white.png';
import '../../assets/fontawesome/css/all.min.css';
import SocialMediaLinks from '../SocialMediaLinks/SocialMediaLinks';
import NavLink from './NavLink';
import { Link } from 'react-router-dom';

const TopNavbar = () => {
  const [opaque, setOpaque] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setOpaque(window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <nav className={opaque ? 'opaque-nav' : ''}>
      <Link to="/">
        <img className="nav-logo ml-4 mr-8" src={logo} alt="LauriMikael" />
      </Link>

      <Link to="/">
        <span className="display-font hidden sm:block sm:text-4xl p-4 text-white">LAURI MIKAEL</span>
      </Link>

      <div className="flex-1"></div>

      <div className="text-white flex flex-col sm:flex-row">
        <NavLink to="/">Etusivu</NavLink>
        <NavLink to="/bio">Biography</NavLink>
        <NavLink to="/keikat">Keikat</NavLink>
        <NavLink to="/musiikki">Musiikki</NavLink>
      </div>

      <SocialMediaLinks />
    </nav>
  );
};

export default TopNavbar;